/* eslint-disable no-redeclare */
<template>
  <div>
    <navbar :title="title"></navbar>
    <div style="padding-top: 80px; background: #fbfbfb">
      <div class="personalMsg-title">
        <img :src="staticImage + 'personalMsgIcon.png'" />
        <span>个人信息</span>
      </div>

      <div class="personalMsg">
        <div class="owner-item">
          <div style="display: flex; width: 100%; align-items: center">
            <span>证件类型</span>
            <!-- <select class="type_select" v-model="type" @change="getType">
              <option v-for="(i,index) in typePickers" :value="i.id" :key="index">{{i.name}}</option>
            </select>-->
            <el-select v-model="type" placeholder="请选择" @change="getType">
              <el-option
                v-for="item in typePickers"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="owner-pic">
          <template v-if="isOtherPage">
            <template v-if="submitData.cardImage">
              <div>
                <img
                  class="norotate"
                  :src="submitData.cardImage"
                  @click="showPic"
                  style="background-color: #fff; object-fit: contain"
                />
                <div class="DelImg" @click="DelImg(1)">
                  <img src="../../public/close.png" />
                </div>
              </div>
            </template>
            <template v-else>
              <div @click="showFloat(1)">
                <span class="jia">+</span>
                <span class="text">上传证件正面照</span>
              </div>
            </template>
          </template>
          <template v-else>
            <template v-if="submitData.cardImage">
              <div>
                <img
                  class="norotate"
                  :src="submitData.cardImage"
                  @click="showPic"
                  style="background-color: #fff; object-fit: contain"
                />
                <div class="DelImg" @click="DelImg(1)">
                  <img src="../../public/close.png" />
                </div>
              </div>
            </template>
            <template v-else>
              <div data-num="1" @click="showFloat(1)">
                <span class="jia">+</span>
                <span class="text">上传身份证正面</span>
              </div>
            </template>
          </template>
          <template v-if="submitData.showPhotoUrl">
            <div>
              <img
                :src="submitData.showPhotoUrl"
                @click="showPic"
                style="width: 100%; height: 100%; object-fit: contain"
              />
              <div class="DelImg" @click="DelImg(2)">
                <img src="../../public/close.png" />
              </div>
            </div>
          </template>
          <template v-else>
            <div @click="showFloat(2)">
              <span class="jia">+</span>
              <span class="text">上传正面人脸照</span>
            </div>
          </template>
        </div>

        <div class="owner-item">
          <div style="display: flex; width: 100%">
            姓名：
            <input
              v-model="submitData.personneName"
              style="width: 81%"
              placeholder="请输入姓名"
              placeholder-style="color:#bfbfbf;font-size: 16px;"
            />
          </div>
        </div>

        <div class="owner-item">
          <div style="display: flex; width: 100%">
            <span>性别：</span>
            <el-select
              v-model="submitData.personneSex"
              placeholder="请选择性别"
            >
              <el-option
                v-for="item in sexPickers"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="owner-item">
          <div style="display: flex; width: 100%">
            <span>民族：</span>
            <!-- <input
              placeholder="请输入民族"
              style="left: -15px;"
              placeholder-style="color:#bfbfbf"
              maxlength="4"
              v-model="info.minzu"
            />-->
            <el-select
              v-model="submitData.nationCode"
              placeholder="请选择"
              @change="getNation"
            >
              <el-option
                v-for="item in minzuPickers"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="owner-item">
          <div style="display: flex; width: 100%; align-items: center">
            <span>政治面貌</span>
            <el-select
              v-model="submitData.zzmmdm"
              placeholder="请选择"
              @change="getZzmm"
            >
              <el-option
                v-for="item in zhengzhiPickers"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="owner-item">
          <div style="display: flex; width: 100%; align-items: center">
            <span>国籍</span>
            <el-select v-model="submitData.country" placeholder="请选择">
              <el-option
                v-for="item in guojiPickers"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="owner-item">
          <div style="display: flex; width: 100%; align-items: center">
            <span>人员标签</span>
            <el-select
              v-model="classify"
              multiple
              collapse-tags
              placeholder="请选择"
              @change="getClassify"
            >
              <el-option
                v-for="item in rybqPickers"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="owner-item">
          <div style="display: flex; width: 100%; align-items: center">
            <span>人口类型</span>
            <el-select v-model="submitData.personneType" placeholder="请选择">
              <el-option
                v-for="item in rklxPickers"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="owner-item">
          <div style="display: flex; width: 100%">
            出生日期：
            <div
              style="position: relative; left: 138px; color: rgb(102, 102, 102)"
              @click="showPopup"
            >
              {{ submitData.birthday }}
            </div>
            <van-popup
              v-model="show"
              position="bottom"
              :style="{ height: '40%' }"
            >
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                title="选择出生日期"
                :min-date="minDate"
                :max-date="maxDate"
                @cancel="showPopup()"
                @confirm="chooseBirth()"
              />
            </van-popup>
          </div>
        </div>
        <div class="owner-item" style="height: 50px">
          <div style="display: flex; width: 100%; position: relative">
            户籍：
            <textarea
              placeholder="请输入户籍"
              placeholder-style="color:#bfbfbf"
              v-model="submitData.permanentAddress"
              style="
                height: 45px;
                width: 245px;
                color: #666;
                text-align: right;
                font-size: 16px;
                border: none;
              "
            ></textarea>
          </div>
        </div>

        <div class="owner-item">
          <div style="display: flex; width: 100%">
            身份证号：
            <input
              placeholder="请输入身份证号"
              placeholder-style="color:#bfbfbf"
              maxlength="18"
              v-model="submitData.personneCardNo"
            />
          </div>
        </div>

        <div class="owner-item">
          <div style="display: flex; width: 100%">
            手机号码：
            <input
              placeholder="请输入手机号码"
              placeholder-style="color:#bfbfbf"
              maxlength="11"
              v-model="submitData.mobile"
            />
          </div>
        </div>

        <div class="owner-item">
          <div style="display: flex; width: 100%; align-items: center">
            <span>文化程度：</span>
            <el-select v-model="submitData.whcd" placeholder="请选择">
              <el-option
                v-for="item in educationPickers"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="owner-item">
          <div style="display: flex; width: 100%; align-items: center">
            <span>婚姻状况：</span>
            <el-select
              v-model="submitData.hyzt"
              placeholder="请选择"
              style="text-align: right"
            >
              <el-option
                v-for="item in marryPickers"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="houseMsg-title">
        <img :src="staticImage + 'houseMsgIcon.png'" />
        <span>房屋信息</span>
      </div>
      <div class="picker">
        <div class="picker-item">
          小区
          <template v-if="hasVillage">
            <!-- <select class="house_select" v-model="village" @change="villagePickersrChange">
              <option v-for="(i,index) in villagePickers" :value="i.id" :key="index">{{i.xqmc}}</option>
            </select>-->
            <el-select
              v-model="village"
              placeholder="请选择"
              @change="villagePickersrChange"
            >
              <el-option
                v-for="item in villagePickers"
                :key="item.id"
                :label="item.xqmc"
                :value="item.id"
              ></el-option>
            </el-select>
          </template>
          <template v-else>
            <div class="picker-select" style="color: #bfbfbf">暂无可选小区</div>
          </template>
        </div>

        <div class="picker-item">
          楼栋
          <template v-if="hasBuildings">
            <!-- <select class="house_select" v-model="building" @change="buildingsPickerChange">
              <option value>请选择</option>
              <option
                v-for="(i,index) in buildingsPickers"
                :value="i.buildingId"
                :key="index"
              >{{i.buildingLabel}}</option>
            </select>-->
            <el-select
              v-model="building"
              placeholder="请选择"
              @change="buildingsPickerChange"
            >
              <el-option
                v-for="item in buildingsPickers"
                :key="item.buildingId"
                :label="item.buildingLabel"
                :value="item.buildingId"
              ></el-option>
            </el-select>
          </template>
          <template v-else>
            <div class="picker-select" style="color: #bfbfbf">暂无可选楼栋</div>
          </template>
        </div>

        <div class="picker-item">
          单元
          <template v-if="hasUnit">
            <!-- <select class="house_select" v-model="unit" @change="unitPickerChange">
              <option value>请选择</option>
              <option v-for="(i,index) in unitPickers" :value="i.unitNo" :key="index">{{i.unitname}}</option>
            </select>-->
            <el-select
              v-model="unit"
              placeholder="请选择"
              @change="unitPickerChange"
            >
              <el-option
                v-for="item in unitPickers"
                :key="item.unitNo"
                :label="item.unitname"
                :value="item.unitNo"
              ></el-option>
            </el-select>
          </template>
          <template v-else>
            <div class="picker-select" style="color: #bfbfbf">暂无可选单元</div>
          </template>
        </div>

        <div class="picker-item">
          房号
          <template v-if="hasHouse">
            <!-- <select class="house_select" v-model="house" @change="housePickersChange">
              <option value>请选择</option>
              <option v-for="(i,index) in housePickers" :value="i.id" :key="index">{{i.roomNo}}</option>
            </select>-->
            <el-select
              v-model="house"
              filterable
              placeholder="请选择"
              @change="housePickersChange"
            >
              <el-option
                v-for="item in housePickers"
                :key="item.id"
                :label="item.roomNo"
                :value="item.id"
              ></el-option>
            </el-select>
          </template>
          <template v-else>
            <div class="picker-select" style="color: #bfbfbf">暂无可选房屋</div>
          </template>
        </div>

        <div class="picker-item">
          身份
          <el-select
            v-model="identity"
            placeholder="请选择"
            @change="identityPickersChange"
          >
            <el-option
              v-for="item in identityPickers"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div class="carMsg-title">
        <img src="../../public/getCar.png" />
        <span>车辆信息</span>
      </div>
      <div class="personalMsg">
        <div class="owner-item">
          <div style="display: flex; width: 100%">
            <span>车牌号：</span>
            <input
              placeholder="请输入车牌号"
              placeholder-style="color:#bfbfbf"
              maxlength="8"
              v-model="carInfo.pNumber"
            />
          </div>
        </div>
        <div class="owner-item">
          <div style="display: flex; width: 100%">
            <span>车辆品牌：</span>
            <input
              placeholder="请输入车辆品牌"
              placeholder-style="color:#bfbfbf"
              maxlength="10"
              v-model="carInfo.brand"
            />
          </div>
        </div>
        <div class="owner-item">
          <div style="display: flex; width: 100%">
            <span>车辆型号：</span>
            <input
              placeholder="请输入车辆型号"
              placeholder-style="color:#bfbfbf"
              v-model="carInfo.cType"
            />
          </div>
        </div>
        <div class="owner-item">
          <div style="display: flex; width: 100%">
            <span>车辆颜色：</span>
            <input
              placeholder="请输入车辆颜色"
              placeholder-style="color:#bfbfbf"
              maxlength="2"
              v-model="carInfo.cColor"
            />
          </div>
        </div>
      </div>
      <div class="submit-btn" @click="submit">
        <span>提交</span>
      </div>
    </div>

    <div v-if="isOtherPage">
      <div v-if="showId">
        <div class="showId">
          <div class="showId-view">
            <div @click="hideFloat" class="close">
              <img src="../../public/close.png" />
            </div>
            <img src="../../public/updateCard.png" />
            <!-- <div class="showId-btn" @click="updateCard">点击上传证件照片</div>
            -->
            <a href="javascript:;" class="file">
              点击上传证件照片
              <input
                type="file"
                @change="updateCard($event)"
                id="uploadFile"
                name
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="showId">
        <div class="showId">
          <div class="showId-view">
            <div @click="hideFloat" class="close">
              <img src="../../public/close.png" />
            </div>
            <img :src="staticImage + 'updateIDcard.png'" />
            <!-- <div class="showId-btn" @click="updateIdCard">点击上传身份照片</div> -->
            <a href="javascript:;" class="file">
              点击上传身份照片
              <input
                type="file"
                @change="updateIdCard($event)"
                accept="image/*"
                id="uploadFile"
                name
              />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showFace">
      <div class="showId">
        <div class="showId-view">
          <div @click="hideFloat" class="close">
            <img src="../../public/close.png" />
          </div>
          <img src="../../public/updateFace.png" />
          <!-- <div class="showId-btn" @click="updateFacePic">点击上传人脸照片</div> -->
          <a href="javascript:;" class="file">
            点击上传人脸照片
            <input
              type="file"
              @change="updateFacePic($event)"
              accept="image/*"
              id="uploadFile"
              name
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  /* eslint-disable */
  data() {
    return {
      showUpload: false,
      show: false, // 是否显示出生日期悬浮层
      minDate: new Date(1900, 0, 1), // 出生日期可选最小时间
      maxDate: new Date(), // 出生日期可选最大时间
      currentDate: new Date(2000, 0, 1), // 当前选中的时间
      title: "人员采集", // 页面标题
      staticImage: this.$common.staticImage, // 静态图片地址
      typePickers: [], // 证件类型pickers
      minzuPickers: [], // 民族类型pickers
      guojiPickers: [], // 国际类型pickers
      rybqPickers: [], // 人员标签piclers
      zhengzhiPickers: [], // 政治面貌pickers
      educationPickers: [], // 文化程度pickers
      marryPickers: [], // 婚姻状况pickers
      villagePickers: [], // 小区pickers
      buildingsPickers: [], // 楼栋pickers
      unitPickers: [], // 单元pickers
      levelPickers: [], // 楼层pickers
      housePickers: [], // 房屋pickers
      identityPickers: [], // 身份pickers
      rklxPickers: [], // 人员类型pickers
      hasVillage: false, // 是否有小区
      hasBuildings: false, // 是否有楼栋
      hasUnit: false, // 是否有单元
      hasLevel: false, // 是否有楼层
      hasHouse: false, // 是否有房屋
      sexPickers: [
        { value: 1, label: "男" },
        { value: 2, label: "女" }
      ],
      info: {
        name: "",
        sex: "",
        addr: "",
        idNo: "",
        facePic: ""
      }, // 信息对象
      carInfo: {
        pNumber: "", // 车牌号
        brand: "", // 车辆品牌
        cType: "", // 车辆型号
        cColor: "" // 车辆颜色
      }, // 车辆信息对象
      classify: [],
      submitData: {
        personneName: null, // 姓名
        personneSex: null, // 性别
        nationCode: null, // 民族代码
        type: 1, // 1：境内 2：境外
        classify: null, // 人员标签
        country: null, // 国际字典code
        birthday: "2000-01-01", // 用户出生日期
        personneCardNo: null, // 用户公民身份证
        permanentAddress: null, // 身份证对应的地址
        residenceAddress: null, // 实际居住地址
        inputType: 2, // 信息录入方式 1读卡录入，2手工录入
        livingWay: 1, /// /居住方式1 单身居住
        checkInState: 1, // 入住状态 0待入住（审核中），1入住，2注销（离开）
        cardImage: null, // 身份证照片
        showPhotoUrl: null, // 人员照片
        mobile: null, // 手机号码
        zzmmdm: null, // 政治面貌代码
        zzmm: null, // 政治面貌
        whcd: null, // 文化程度
        hyzt: null, // 婚姻状况
        zjlx: 0, // 证件类型
        grantWay: 1, // 授权方式
        personneType: null, // 人口类型
        houseIdsStr: [], // 多个参数新增时使用
        houseIdsStrs: [],
        toBeginTime: null, // 入住开始时间
        toEndTime: null, // 入住开始时间
        houseId: null, // 房屋id
        relation: null, // 人员关系
        fwbm: null, // 房屋编码
        xqbm: null, // 小区编码
        buildingId: null, // 楼栋id
        communityId: null, // 小区id
        type: null, // 类型 0：不是 1：是户主
        status: 0, // 0：在家；1：外出；2：搬离
        jtgxdm: null, // 家庭关系代码
        personHouseRelationDomain: {},
        personalCarDomains: [
          // pNumber: null, //车牌号
          // brand: null, //车辆品牌
          // cType: null, //车辆型号
          // cColor: null //车辆颜色
        ]
      }, // 提交数据对象
      type: "", // 被选中的证件类型
      village: "", // 小区
      building: "", // 楼栋
      unit: "", // 单元
      level: "", // 楼层
      house: "", // 房屋
      identity: "", // 身份
      isOtherPage: false, // 证件类型是否是身份证,false即是身份证
      showId: false, // 显示身份证上传浮窗
      showFace: false, // 显示人脸上传浮窗
      isMark: true, // 是否标记周末
      showDatePicker: false, // 是否显示日期选择器
      villageParams: {}, // 获取小区请求数据
      buildingParams: {
        communityId: null, // 小区id
        xqbm: null // 小区编码
      }, // 获取楼栋请求数据
      housesParams: {
        communityId: null, // 小区id
        buildingId: null, // 楼栋id
        dyh: null // 单元号
        // level: null, //楼层
      }, // 获取房屋时请求数据
      rotateData: {
        picData: null // 照片变量
      }, // 判断身份证照片是否歪了
      postDataId: {
        picData: null
      }, // 身份证识别请求数据
      faceData: {
        destData: "", // 身份证照片
        srcData: "" // 人脸照片
      }, // 人脸比对请求数据
      a: {
        picData: null
      }, // 人脸照片剪裁请求数据
      getListByCode: {
        codes: [
          "certificate_type",
          "MZDM",
          "GJDM",
          "person_label",
          "politics_visage",
          "culture",
          "marital_status",
          "FAMILY_TIES",
          "RKLXDM"
        ]
      },
      unitObj: null, // 获取单元时的一个中间data变量
      xqmc: null, // 小区名称
      buildingLabel: null, // 楼栋
      unitname: null, // 单元
      roomNo: null, // 房间号
      touched: true // 是否可以点击提交按钮
    };
  },
  mounted() {
    var that = this;
    that.submitData.personneSex = that.sexPickers[0].value;
    that
      .post("api-apmuc/communityRest/queryCommunitys", that.villageParams)
      .then(res => {
        if (res.data.length) {
          that.hasVillage = true;
          that.villagePickers = res.data;
          that.village = that.villagePickers[0].id;
          that.buildingParams.communityId = that.villagePickers[0].id;
          that.submitData.communityId = that.villagePickers[0].id;
          that.xqmc = that.villagePickers[0].xqmc;
          that.buildingParams.xqbm = that.villagePickers[0].xqbm;
          that.submitData.xqbm = that.villagePickers[0].xqbm;
          that.housesParams.communityId = that.villagePickers[0].id;
          that
            .post(
              "api-apmuc/buildingRest/queryBuildingByCid",
              that.buildingParams
            )
            .then(r => {
              if (r.data.buildingInfo.length) {
                that.hasBuildings = true;
                that.buildingsPickers = r.data.buildingInfo;
                // that.building = that.buildingsPickers[0].buildingId;
              }
            });
        }
      });
    const code = that.getListByCode.codes;
    const args = {
      codes: `${code[0]},${code[1]},${code[2]},${code[3]},${code[4]},${code[5]},${code[6]},${code[7]},${code[8]}`
    };
    that.get("api-user/dict/listByCode", args).then(res => {
      this.typePickers = res.CERTIFICATE_TYPE;
      this.type = res.CERTIFICATE_TYPE[0].code;
      this.minzuPickers = res.MZDM;
      this.submitData.nationCode = res.MZDM[0].code;
      this.submitData.nationality = res.MZDM[0].name;
      this.guojiPickers = res.GJDM;
      this.submitData.country = res.GJDM[0].code;
      this.rybqPickers = res.PERSON_LABEL;
      this.zhengzhiPickers = res.POLITICS_VISAGE;
      this.submitData.zzmmdm = res.POLITICS_VISAGE[12].code;
      this.submitData.zzmm = res.POLITICS_VISAGE[12].name;
      this.educationPickers = res.CULTURE;
      this.submitData.whcd = res.CULTURE[0].code;
      this.marryPickers = res.MARITAL_STATUS;
      this.identityPickers = res.FAMILY_TIES;
      this.rklxPickers = res.RKLXDM;
    });
  },
  methods: {
    // 底部弹出
    showPopup() {
      this.show = !this.show;
    },
    getClassify(val) {
      this.submitData.classify = val.join(",");
    },
    // 出生日期选择
    chooseBirth() {
      this.showPopup();
      var year = this.currentDate.getFullYear();
      if (this.currentDate.getMonth() + 1 < 10) {
        var month = "0" + (this.currentDate.getMonth() + 1);
      } else {
        var month = this.currentDate.getMonth() + 1;
      }
      if (this.currentDate.getDate() < 10) {
        var day = "0" + this.currentDate.getDate();
      } else {
        var day = this.currentDate.getDate();
      }
      var date = year + "-" + month + "-" + day;
      this.submitData.birthday = date;
    },
    // 证件类型选择
    getType(val) {
      this.submitData.zjlx = val;
      this.submitData.cardImage = null;
      this.submitData.showPhotoUrl = null;
      if (this.type != 0) {
        this.isOtherPage = true;
      } else {
        this.isOtherPage = false;
      }
      if (this.type != 0 && this.type != 1) {
        this.submitData.type = 2;
      } else {
        this.submitData.type = 1;
      }
    },
    // 获取政治面貌
    getZzmm(val) {
      const name = this.zhengzhiPickers.filter(item => {
        return item.code == val;
      });
      this.submitData.zzmm = name[0].name;
    },
    // 获取民族
    getNation(val) {
      const name = this.minzuPickers.filter(item => {
        return item.code == val;
      });
      this.submitData.nationality = name[0].name;
    },
    // 小区选择
    villagePickersrChange() {
      var that = this;
      that.villagePickers.map((item, i) => {
        if (item.id == that.village) {
          that.buildingParams.communityId = item.id;
          that.submitData.communityId = item.id;
          that.buildingParams.xqbm = item.xqbm;
          that.submitData.xqbm = item.xqbm;
          that.xqmc = item.xqmc;
          that.buildingLabel = null;
          that.unitname = null;
          that.roomNo = null;
        }
      });
      that
        .post("api-apmuc/buildingRest/queryBuildingByCid", that.buildingParams)
        .then(res => {
          if (res.data.buildingInfo.length) {
            that.housesParams.communityId = res.data.communityInfo.id;
            that.hasBuildings = true;
            that.buildingsPickers = res.data.buildingInfo;
            that.building = "";
            that.unit = "";
            that.level = "";
            that.house = "";
            that.hasUnit = false;
            that.hasLevel = false;
            that.hasHouse = false;
          } else {
            that.hasBuildings = false;
          }
        });
    },
    // 楼栋选择
    buildingsPickerChange() {
      var that = this;
      that.buildingsPickers.map((item, i) => {
        if (item.buildingId == that.building) {
          that.housesParams.buildingId = item.buildingId;
          that.submitData.buildingId = item.buildingId;
          that.buildingLabel = item.buildingLabel;
          that.unitname = null;
          that.roomNo = null;
          // 新接口数据处理 start
          var centerArr = new Array();
          for (var index = 0; index < item.unitObjs.length; index++) {
            centerArr.push(item.unitObjs[index].dyName);
          }
          // 新接口数据处理 end
          var unitObj = centerArr;
          var arr = new Array();
          var arr1 = new Array();
          for (var i = 0; i < unitObj.length; i++) {
            for (var key in unitObj[i]) {
              // arr1.push(key);
              arr1.push(unitObj[i]);
              // 排序 从小到大
              var min;
              for (var q = 0; q < arr1.length; q++) {
                for (var j = q; j < arr1.length; j++) {
                  if (arr1[q] > arr1[j]) {
                    min = arr1[j];
                    arr1[j] = arr1[q];
                    arr1[q] = min;
                  }
                }
              }
              that.unitObj = unitObj;
              // 排序 从小到大
            }
          }
          for (var a in arr1) {
            arr.push({
              unitname: arr1[a] + "单元",
              unitNo: arr1[a]
            });
          }
          that.unitPickers = arr;
          if (that.unitPickers.length) {
            that.hasUnit = true;
          } else {
            that.hasUnit = false;
          }
        }
      });
    },
    // 单元选择
    unitPickerChange() {
      var that = this;
      // that.housesParams.level = null;
      var chooseUnit = null;
      that.unitPickers.map((item, i) => {
        if (item.unitNo == that.unit) {
          chooseUnit = item.unitNo;
          that.housesParams.dyh = item.unitNo;
          that.unitname = item.unitname;
          that.roomNo = null;
        }
      });
      that
        .post("api-apmuc/houseRest/queryHouses", that.housesParams)
        .then(res => {
          for (var i in res.data) {
            if (res.data[i].roomNo.substring(0, 1) == "-") {
              res.data[i].roomNo = "负" + res.data[i].roomNo.substring(1, 4);
            }
          }
          that.housePickers = res.data;
          that.house = "";
          if (that.housePickers.length) {
            that.hasHouse = true;
          } else {
            that.hasHouse = false;
          }
        });
    },
    // 房屋选择
    housePickersChange() {
      var that = this;
      that.housePickers.map((item, i) => {
        if (item.id == that.house) {
          this.submitData.fwbm = item.fwbm;
          this.submitData.houseId = item.id;
          this.submitData.houseIdsStr[0] = item.id;
          this.houseIdsStrs = item.id;
          this.roomNo = item.roomNo;
        }
      });
    },
    // 身份选择
    identityPickersChange() {
      var that = this;
      that.identityPickers.map((item, i) => {
        if (item.id == that.identity) {
          this.submitData.relation = item.name;
          this.submitData.jtgxdm = item.code;
          this.submitData.houseIdsStr[0] = this.houseIdsStrs + "," + item.code;
          if (item.name == "户主" || item.name == "租户主") {
            this.submitData.type = 1;
          } else {
            this.submitData.type = 0;
          }
        }
      });
    },
    // 身份证上传回调方法
    callbackId(e) {
      this.chooseIdCard(e);
    },
    // 人脸照片上传回调方法
    callbackFace(e) {
      this.chooseFacePic(e);
    },
    // 证件照片上传回调方法
    callbackCard(e) {
      var centerPic = "data:image/jpeg;base64," + e;
      this.chooseCard(centerPic);
    },
    // 身份证照片上传
    updateIdCard(e) {
      this.getPic(e.target.files[0], this.callbackId);
    },
    // 证件照片上传
    updateCard(e) {
      const imgSrc = window.URL.createObjectURL(e.target.files[0]);
      var url = this.compressImg(imgSrc, this.callbackCard);
    },
    // 人脸照片上传
    updateFacePic(e) {
      // this.getPic(e.target.files[0], this.callbackFace);
      const that = this;
      const imgTools = require("../utils/imgTools");
      var file = e.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function(e) {
        var image = imgTools.showImg(e.target.result);
        setTimeout(() => {
          imgTools.compressImg(image);
          // 获取角度1 6 3 8
          const orientation = imgTools.getOrientation(
            imgTools.base64ToArrayBuffer(e.target.result)
          );

          const canvas = document.createElement("canvas");
          let canvasWidth = image.width; // 图片原始长宽
          let canvasHeight = image.height;
          const base = canvasWidth / canvasHeight;
          if (canvasWidth > 700) {
            canvasWidth = 700;
            canvasHeight = Math.floor(canvasWidth / base);
          }
          canvas.width = canvasWidth;
          canvas.height = canvasHeight;
          var baseStr;
          switch (orientation) {
            case 6: // 需要顺时针（向左）90度旋转
              // console.log('（向左）90度旋转')
              baseStr = imgTools.rotateImg(image, "right", canvas);
              break;
            case 8: // 需要逆时针（向右）90度旋转
              // console.log('（向右）90度旋转')
              baseStr = imgTools.rotateImg(image, "left", canvas);
              break;

            case 3: // 需要180度旋转 转两次
              // console.log('需要180度旋转')
              baseStr = imgTools.rotateImg(image, "right", canvas, 2);
              break;
            default:
              baseStr = imgTools.rotateImg(image, "", canvas);
              break;
          }
          var userAgent = window.navigator.userAgent.toLowerCase();
          var ios = /iphone|ipod|ipad/.test(userAgent);
          if (ios && orientation == 6) {
            baseStr = imgTools.rotateImg(image, "", canvas);
          }
          baseStr = baseStr.split("base64,")[1];

          // return
          // setTimeout(callback(baseStr), 3000);
          setTimeout(() => {
            if (that.isOtherPage) {
              that.$toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: "上传中..."
              });
              that.a.picData = baseStr;

              // 人脸检测
              that
                .post("api-algo/frpRest/faceDetect", that.a)
                .then(res => {
                  that.hideFloat();
                  if (res.status == 0) {
                    if (res.data.length > 1) {
                      that.$toast.fail("请上传单张人脸!");
                      return false;
                    }
                    // 人脸（活体）检测
                    that
                      .post("api-algo/frpRest/faceLiveDetect", that.a)
                      .then(r => {
                        if (r.data == null) {
                          that.$toast.fail("请上传正确的人脸照片！");
                        } else {
                          that.submitData.showPhotoUrl =
                            "data:image/jpeg;base64," + r.data.picture;
                          that.$toast.clear();
                        }
                      })
                      .catch(r => {
                        that.$toast.fail(
                          "照片不符合标准，请调整光线和角度重新拍摄！"
                        );
                      });
                  } else {
                    // 人脸旋转
                    that
                      .post("api-algo/frpRest/faceDetectRotate", that.a)
                      .then(r => {
                        if (r.data) {
                          let pic = r.data.picData;
                          // 人脸（活体）检测
                          that
                            .post("api-algo/frpRest/faceLiveDetect", {
                              picData: pic
                            })
                            .then(r => {
                              if (r.data == null) {
                                that.$toast.fail("请上传正确的人脸照片！");
                              } else {
                                that.submitData.showPhotoUrl =
                                  "data:image/jpeg;base64," + r.data.picture;
                                that.$toast.clear();
                              }
                            })
                            .catch(r => {
                              that.$toast.fail(
                                "照片不符合标准，请调整光线和角度重新拍摄！"
                              );
                            });
                        } else {
                          that.$toast.fail("请上传正确的人脸照片！");
                        }
                      })
                      .catch(r => {
                        that.$toast.fail(
                          "照片不符合标准，请调整光线和角度重新拍摄！"
                        );
                      });
                  }
                })
                .catch(r => {
                  that.hideFloat();
                  // 人脸旋转
                  that
                    .post("api-algo/frpRest/faceDetectRotate", that.a)
                    .then(r => {
                      if (r.data) {
                        let pic = r.data.picData;
                        // 人脸（活体）检测
                        that
                          .post("api-algo/frpRest/faceLiveDetect", {
                            picData: pic
                          })
                          .then(r => {
                            if (r.data == null) {
                              that.$toast.fail("请上传正确的人脸照片！");
                            } else {
                              that.submitData.showPhotoUrl =
                                "data:image/jpeg;base64," + r.data.picture;
                              that.$toast.clear();
                            }
                          })
                          .catch(r => {
                            that.$toast.fail(
                              "照片不符合标准，请调整光线和角度重新拍摄！"
                            );
                          });
                      } else {
                        that.$toast.fail("请上传正确的人脸照片！");
                      }
                    })
                    .catch(r => {
                      that.$toast.fail(r.response.data.errMsg);
                    });
                });
            } else {
              if (!that.submitData.cardImage) {
                that.$toast("请先上传身份证照片");
                that.hideFloat();
              } else {
                that.$toast.loading({
                  duration: 0, // 持续展示 toast
                  forbidClick: true,
                  message: "上传中..."
                });
                that.faceData.destData = that.submitData.cardImage;
                that.a.picData = baseStr;

                // 人脸检测
                that
                  .post("api-algo/frpRest/faceDetect", that.a)
                  .then(res => {
                    that.hideFloat();
                    if (res.status == 0) {
                      if (res.data.length > 1) {
                        that.$toast.fail("请上传单张人脸!");
                        return false;
                      }
                      // 人脸（活体）检测
                      that
                        .post("api-algo/frpRest/faceLiveDetect", that.a)
                        .then(r => {
                          if (r.data == null) {
                            that.$toast.fail("请上传正确的人脸照片！");
                          } else {
                            that.faceData.srcData =
                              "data:image/jpeg;base64," + r.data.picture;
                            that.submitData.showPhotoUrl =
                              "data:image/jpeg;base64," + r.data.picture;
                            that.$toast.clear();

                            // 人脸与身份证对比
                            /*  that
                        .post("api-algo/frpRest/faceCompare", that.faceData)
                        .then(res => {
                          if (res.data.isSame == 1) {
                            that.submitData.showPhotoUrl =
                              "data:image/jpeg;base64," + r.data.picture;
                            that.$toast.clear();
                          } else {
                            that.$toast.fail("人脸照与身份证不一致");
                          }
                        }); */
                          }
                        })
                        .catch(r => {
                          that.$toast.fail(
                            "照片不符合标准，请调整光线和角度重新拍摄！"
                          );
                        });
                    } else {
                      // 人脸旋转
                      that
                        .post("api-algo/frpRest/faceDetectRotate", that.a)
                        .then(r => {
                          if (r.data) {
                            let pic = r.data.picData;
                            // 人脸（活体）检测
                            that
                              .post("api-algo/frpRest/faceLiveDetect", pic)
                              .then(r => {
                                if (r.data == null) {
                                  that.$toast.fail("请上传正确的人脸照片！");
                                } else {
                                  that.faceData.srcData =
                                    "data:image/jpeg;base64," + r.data.picture;
                                  that.submitData.showPhotoUrl =
                                    "data:image/jpeg;base64," + r.data.picture;
                                  that.$toast.clear();
                                }
                              })
                              .catch(r => {
                                that.$toast.fail(
                                  "照片不符合标准，请调整光线和角度重新拍摄！"
                                );
                              });
                          } else {
                            that.$toast.fail("请上传正确的人脸照片！");
                          }
                        })
                        .catch(r => {
                          that.$toast.fail(
                            "照片不符合标准，请调整光线和角度重新拍摄！"
                          );
                        });
                    }
                  })
                  .catch(r => {
                    that.hideFloat();
                    // 人脸旋转
                    that
                      .post("api-algo/frpRest/faceDetectRotate", that.a)
                      .then(r => {
                        if (r.data) {
                          let pic = r.data.picData;
                          // 人脸（活体）检测
                          that
                            .post("api-algo/frpRest/faceLiveDetect", pic)
                            .then(r => {
                              if (r.data == null) {
                                that.$toast.fail("请上传正确的人脸照片！");
                              } else {
                                that.faceData.srcData =
                                  "data:image/jpeg;base64," + r.data.picture;
                                that.submitData.showPhotoUrl =
                                  "data:image/jpeg;base64," + r.data.picture;
                                that.$toast.clear();
                              }
                            })
                            .catch(r => {
                              that.$toast.fail(
                                "照片不符合标准，请调整光线和角度重新拍摄！"
                              );
                            });
                        } else {
                          that.$toast.fail("请上传正确的人脸照片！");
                        }
                      })
                      .catch(r => {
                        // console.log(r.response.data.errMsg);
                        that.$toast.fail(r.response.data.errMsg);
                      });
                  });
              }
            }
          }, 1000);
        }, 1000);
      };
    },
    getPic(picurl, callback) {
      const imgTools = require("../utils/imgTools");
      var file = picurl;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function(e) {
        var image = imgTools.showImg(e.target.result);
        setTimeout(() => {
          imgTools.compressImg(image);
          // 获取角度1 6 3 8
          const orientation = imgTools.getOrientation(
            imgTools.base64ToArrayBuffer(e.target.result)
          );

          const canvas = document.createElement("canvas");
          let canvasWidth = image.width; // 图片原始长宽
          let canvasHeight = image.height;
          const base = canvasWidth / canvasHeight;
          if (canvasWidth > 700) {
            canvasWidth = 700;
            canvasHeight = Math.floor(canvasWidth / base);
          }
          canvas.width = canvasWidth;
          canvas.height = canvasHeight;
          var baseStr;
          console.log(orientation);
          switch (orientation) {
            case 6: // 需要顺时针（向左）90度旋转
              // console.log('（向左）90度旋转')
              baseStr = imgTools.rotateImg(image, "right", canvas);
              break;
            case 8: // 需要逆时针（向右）90度旋转
              // console.log('（向右）90度旋转')
              baseStr = imgTools.rotateImg(image, "left", canvas);
              break;

            case 3: // 需要180度旋转 转两次
              // console.log('需要180度旋转')
              baseStr = imgTools.rotateImg(image, "right", canvas, 2);
              break;
            default:
              baseStr = imgTools.rotateImg(image, "", canvas);
              break;
          }

          setTimeout(callback(baseStr), 3000);
        }, 1000);
      };
    },
    // 证件照片上传子方法
    chooseIdCard(e) {
      var that = this;
      that.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "上传中..."
      });
      that.postDataId.picData = e;
      that
        .post("api-algo/ocrRest/ocrIDCard", that.postDataId)
        .then(r => {
          if (r.status == -1) {
            that.$toast.fail("识别失败");
          } else {
            that.submitData.personneName = r.data.name;
            that.submitData.permanentAddress = r.data.address;
            that.submitData.personneCardNo = r.data.number;
            that.submitData.birthday = r.data.birth;
            if (r.data.sex == "男") {
              that.submitData.personneSex = 1;
            } else if (r.data.sex == "女") {
              that.submitData.personneSex = 2;
            }
            that.submitData.cardImage = e;
            const name = this.minzuPickers.filter(item => {
              if (r.data.ethnicity) {
                if (item.name.indexOf(r.data.ethnicity) != -1) {
                  return (item.name = r.data.ethnicity + "族");
                }
              }
            });
            if (name.length > 0) {
              this.submitData.nationality = name[0].name;
              this.submitData.nationCode = name[0].code;
            }

            that.$toast.clear();
          }
        })
        .catch(r => {
          that.$toast.fail("请上传正确的身份证照片");
        });
      that.hideFloat();
    },

    // 人脸照片上传子方法
    chooseFacePic(e) {
      let baseStr = e.split("base64,")[1];
      const that = this;
      if (that.isOtherPage) {
        that.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: "上传中..."
        });
        that.a.picData = baseStr;

        // 人脸检测
        that
          .post("api-algo/frpRest/faceDetect", that.a)
          .then(res => {
            that.hideFloat();
            if (res.status == 0) {
              if (res.data.length > 1) {
                that.$toast.fail("请上传单张人脸!");
                return false;
              }

              // 人脸（活体）检测
              that
                .post("api-algo/frpRest/faceLiveDetect", that.a)
                .then(r => {
                  if (r.data == null) {
                    that.$toast.fail("请上传正确的人脸照片！");
                  } else {
                    that.submitData.showPhotoUrl =
                      "data:image/jpeg;base64," + r.data.picture;
                    that.$toast.clear();
                  }
                })
                .catch(r => {
                  that.$toast.fail(
                    "照片不符合标准，请调整光线和角度重新拍摄！"
                  );
                });
            } else {
              // 人脸旋转
              that
                .post("api-algo/frpRest/faceDetectRotate", that.a)
                .then(r => {
                  if (r.data) {
                    let pic = r.data.picData;
                    // 人脸（活体）检测
                    that
                      .post("api-algo/frpRest/faceLiveDetect", pic)
                      .then(r => {
                        if (r.data == null) {
                          that.$toast.fail("请上传正确的人脸照片！");
                        } else {
                          that.submitData.showPhotoUrl =
                            "data:image/jpeg;base64," + r.data.picture;
                          that.$toast.clear();
                        }
                      })
                      .catch(r => {
                        that.$toast.fail(
                          "照片不符合标准，请调整光线和角度重新拍摄！"
                        );
                      });
                  } else {
                    that.$toast.fail("请上传正确的人脸照片！");
                  }
                })
                .catch(r => {
                  that.$toast.fail(
                    "照片不符合标准，请调整光线和角度重新拍摄！"
                  );
                });
            }
          })
          .catch(r => {
            that.hideFloat();
            // 人脸旋转
            that
              .post("api-algo/frpRest/faceDetectRotate", that.a)
              .then(r => {
                if (r.data) {
                  let pic = r.data.picData;
                  // 人脸（活体）检测
                  that
                    .post("api-algo/frpRest/faceLiveDetect", pic)
                    .then(r => {
                      if (r.data == null) {
                        that.$toast.fail("请上传正确的人脸照片！");
                      } else {
                        that.submitData.showPhotoUrl =
                          "data:image/jpeg;base64," + r.data.picture;
                        that.$toast.clear();
                      }
                    })
                    .catch(r => {
                      that.$toast.fail(
                        "照片不符合标准，请调整光线和角度重新拍摄！"
                      );
                    });
                } else {
                  that.$toast.fail("请上传正确的人脸照片！");
                }
              })
              .catch(r => {
                that.$toast.fail(r.response.data.errMsg);
              });
          });
      } else {
        if (!that.submitData.cardImage) {
          this.$toast("请先上传身份证照片");
          that.hideFloat();
        } else {
          that.$toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: "上传中..."
          });
          that.faceData.destData = that.submitData.cardImage;
          that.a.picData = baseStr;

          // 判断有没有人脸
          that
            .post("api-algo/frpRest/faceDetect", that.a)
            .then(res => {
              that.hideFloat();
              if (res.status == 0) {
                if (res.data.length > 1) {
                  that.$toast.fail("请上传单张人脸!");
                  return false;
                }

                // 人脸（活体）检测
                that
                  .post("api-algo/frpRest/faceLiveDetect", that.a)
                  .then(r => {
                    if (r.data == null) {
                      that.$toast.fail("请上传正确的人脸照片！");
                    } else {
                      that.submitData.showPhotoUrl =
                        "data:image/jpeg;base64," + r.data.picture;
                      that.$toast.clear();
                    }
                  })
                  .catch(r => {
                    that.$toast.fail(
                      "照片不符合标准，请调整光线和角度重新拍摄！"
                    );
                  });
              } else {
                // 人脸旋转
                that
                  .post("api-algo/frpRest/faceDetectRotate", that.a)
                  .then(r => {
                    if (r.data) {
                      let pic = r.data.picData;
                      // 人脸（活体）检测
                      that
                        .post("api-algo/frpRest/faceLiveDetect", pic)
                        .then(r => {
                          if (r.data == null) {
                            that.$toast.fail("请上传正确的人脸照片！");
                          } else {
                            that.submitData.showPhotoUrl =
                              "data:image/jpeg;base64," + r.data.picture;
                            that.$toast.clear();
                          }
                        })
                        .catch(r => {
                          that.$toast.fail(
                            "照片不符合标准，请调整光线和角度重新拍摄！"
                          );
                        });
                    } else {
                      that.$toast.fail("请上传正确的人脸照片！");
                    }
                  })
                  .catch(r => {
                    that.$toast.fail(
                      "照片不符合标准，请调整光线和角度重新拍摄！"
                    );
                  });
              }
            })
            .catch(r => {
              that.hideFloat();
              // 人脸旋转
              that
                .post("api-algo/frpRest/faceDetectRotate", that.a)
                .then(r => {
                  if (r.data) {
                    let pic = r.data.picData;
                    // 人脸（活体）检测
                    that
                      .post("api-algo/frpRest/faceLiveDetect", pic)
                      .then(r => {
                        if (r.data == null) {
                          that.$toast.fail("请上传正确的人脸照片！");
                        } else {
                          that.submitData.showPhotoUrl =
                            "data:image/jpeg;base64," + r.data.picture;
                          that.$toast.clear();
                        }
                      })
                      .catch(r => {
                        that.$toast.fail(
                          "照片不符合标准，请调整光线和角度重新拍摄！"
                        );
                      });
                  } else {
                    that.$toast.fail("请上传正确的人脸照片！");
                  }
                })
                .catch(r => {
                  // console.log(r.response.data.errMsg);
                  that.$toast.fail(r.response.data.errMsg);
                });
            });
        }
      }
    },
    // 证件照片上传子方法
    chooseCard(e) {
      this.submitData.cardImage = e;
      this.hideFloat();
    },
    // 提交方法
    submit() {
      if (
        this.carInfo.pNumber != "" &&
        this.carInfo.brand != "" &&
        this.carInfo.cType != "" &&
        this.carInfo.cColor != ""
      ) {
        this.submitData.personalCarDomains[0] = this.carInfo;
      } else {
        if (
          this.carInfo.pNumber == "" &&
          this.carInfo.brand == "" &&
          this.carInfo.cType == "" &&
          this.carInfo.cColor == ""
        ) {
        } else {
          this.$dialog.alert({
            title: "提示",
            message: "请将车辆信息填写完整"
          });
          return;
        }
      }
      this.submitData.residenceAddress =
        this.xqmc + this.buildingLabel + this.unitname + +this.roomNo;
      if (
        !this.submitData.personneName ||
        !this.submitData.personneSex ||
        !this.submitData.nationCode ||
        !this.submitData.personneType ||
        !this.submitData.birthday ||
        !this.submitData.permanentAddress ||
        !this.submitData.cardImage ||
        !this.submitData.showPhotoUrl ||
        !this.submitData.personneCardNo ||
        !this.submitData.whcd ||
        !this.submitData.hyzt
      ) {
        if (!this.submitData.cardImage) {
          this.$dialog.alert({
            title: "提示",
            message: "请上传证件照"
          });
        } else if (!this.submitData.showPhotoUrl) {
          this.$dialog.alert({
            title: "提示",
            message: "请上传人脸照"
          });
        } else if (!this.submitData.personneName) {
          this.$dialog.alert({
            title: "提示",
            message: "请填写姓名"
          });
        } else if (!this.submitData.personneSex) {
          this.$dialog.alert({
            title: "提示",
            message: "请填写性别"
          });
        } else if (!this.submitData.personneType) {
          this.$dialog.alert({
            title: "提示",
            message: "请选择人口类型"
          });
        } else if (!this.submitData.nationCode) {
          this.$dialog.alert({
            title: "提示",
            message: "请选择民族"
          });
        } else if (!this.submitData.birthday) {
          this.$dialog.alert({
            title: "提示",
            message: "请选择出生日期"
          });
        } else if (!this.submitData.permanentAddress) {
          this.$dialog.alert({
            title: "提示",
            message: "请填写户籍"
          });
        } else if (!this.submitData.personneCardNo) {
          this.$dialog.alert({
            title: "提示",
            message: "请填写身份证号码"
          });
        } else if (!this.submitData.whcd) {
          this.$dialog.alert({
            title: "提示",
            message: "请选择文化程度"
          });
        } else if (!this.submitData.hyzt) {
          this.$dialog.alert({
            title: "提示",
            message: "请选择婚姻状态"
          });
        }
      } else if (
        this.submitData.houseId == null ||
        this.submitData.relation == null ||
        this.submitData.fwbm == null ||
        this.submitData.xqbm == null ||
        this.submitData.type == null ||
        this.submitData.jtgxdm == null
      ) {
        this.$dialog.alert({
          title: "提示",
          message: "请将房屋信息填写完整"
        });
      } else {
        if (this.submitData.type == 1) {
          if (!this.submitData.mobile) {
            this.$dialog.alert({
              title: "提示",
              message: "请填写手机号"
            });
            return;
          }
          if (!/^1[3456789]\d{9}$/.test(this.submitData.mobile)) {
            this.$dialog.alert({
              title: "提示",
              message: "请填写正确的手机号码"
            });
            return;
          }
        } else {
          if (!this.submitData.mobile) {
            this.$dialog.alert({
              title: "提示",
              message: "请填写手机号"
            });
            return;
          }
          if (!/^1[3456789]\d{9}$/.test(this.submitData.mobile)) {
            this.$dialog.alert({
              title: "提示",
              message: "请填写正确的手机号码"
            });
            return;
          }
        }
        if (this.submitData.zjlx == 0 || this.submitData.zjlx == 1) {
          if (
            !/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
              this.submitData.personneCardNo
            )
          ) {
            this.$dialog.alert({
              title: "提示",
              message: "请填写正确的身份证号码"
            });
            return;
          }
        }
        if (this.touched) {
          this.touched = false;
          this.post(
            "api-apmuc/personHouseRelationRest/v2.0/addMultiPersonHouseRelation",
            this.submitData
          )
            .then(res => {
              if (res.status == 0) {
                this.$toast.success({
                  message: "添加成功",
                  duration: 5000
                });
                this.touched = true;
              } else {
                this.$toast(res.errMsg);
                this.touched = true;
              }
            })
            .catch(r => {
              this.$toast.fail("添加失败");
              this.touched = true;
            });
        }
      }
    },
    // 显示悬浮框
    showFloat(e) {
      if (e == 1) {
        this.showId = true;
      } else {
        this.showFace = true;
      }
    },
    // 隐藏悬浮框
    hideFloat() {
      this.showId = false;
      this.showFace = false;
    },
    // 点击图片可放大
    showPic() {},
    // 删除图片
    DelImg(e) {
      this.$dialog
        .confirm({
          title: "删除图片",
          message: "确定要删除这张图片吗",
          confirmButtonColor: "#2dc5e0"
        })
        .then(() => {
          if (e == 1) {
            this.submitData.cardImage = null;
            this.submitData.showPhotoUrl = null;
          } else if (e == 2) {
            this.submitData.showPhotoUrl = null;
          }
        })
        .catch(() => {});
    },
    handleCancel() {
      this.showDatePicker = false;
    },
    handleConfirm(item) {
      this.submitData.birthday = item;
      this.showDatePicker = false;
    },
    disableDate(item) {
      if (
        new Date(item) - new Date("2019-8-10") >= 0 &&
        new Date("2019-8-20") - new Date(item) >= 0
      ) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style scoped>
.personalMsg {
  width: 90%;
  margin: 15px auto;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 0 5px #ccc;
}
.personalMsg-title {
  width: 90%;
  margin: 15px auto;
  font-size: 16px;
}
.personalMsg-title > img {
  width: 30px;
  height: 22.5px;
  position: relative;
  top: 5px;
}
.personalMsg-title > span {
  margin-left: 15px;
}
.owner-item {
  width: 90%;
  margin: 0 auto;
  border-bottom: 1px solid #e6e6e6;
  padding: 15px 0;
  display: flex;
  font-size: 16px;
}
.owner-item:last-child {
  border-bottom: none;
}
.owner-item > div:nth-child(2) {
  position: relative;
  left: 15px;
}
.owner-item > div > span {
  width: 85px;
  display: flex;
  align-items: center;
}
.owner-item > div > input {
  width: 70%;
  text-align: right;
  color: #666;
  /* font-weight: normal; */ /* display: inline-block;*/
  top: 5px;
  position: relative;
  z-index: 0;
  border: none;
  font-size: 16px;
}
.type_select {
  width: 180px;
  font-size: 16px;
  height: 26px;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #fff;
  direction: rtl;
}
.house_select {
  width: 130px;
  font-size: 16px;
  height: 26px;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #fff;
  direction: rtl;
}
.owner-pic {
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
}
.norotate {
  width: 100%;
  height: 100%;
}
.owner-pic > div {
  width: 130px;
  height: 130px;
  margin: 15px 0;
  border: 1px dashed #ccc;
  text-align: center;
  color: #ccc;
  overflow: hidden;
}
.jia {
  display: block;
  position: relative;
  top: 22px;
  font-size: 40px;
}
.text {
  display: block;
  position: relative;
  top: 25px;
  font-size: 16px;
}
.picker {
  width: 90%;
  margin: 0 auto;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 0 5px #ccc;
  margin-bottom: 25px;
  font-size: 16px;
}
.picker-select {
  color: #666;
  height: 40px;
  display: flex;
  align-items: center;
}
.picker-select > text {
  margin-right: 12rpx;
}
.houseMsg-title {
  width: 90%;
  margin: 15px auto;
  font-size: 16px;
}
.houseMsg-title > img {
  width: 35px;
  height: 22px;
  position: relative;
  top: 5px;
}
.houseMsg-title > span {
  margin-left: 10px;
}
.picker-item {
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #e6e6e6;
}
.picker-item:last-child {
  border-bottom: none;
}
.carMsg-title {
  width: 90%;
  margin: 15px auto;
  font-size: 16px;
}
.carMsg-title > img {
  width: 26px;
  height: 23px;
  position: relative;
  top: 5px;
}
.carMsg-title > span {
  margin-left: 10px;
}
.submit-btn {
  width: 90%;
  height: 50px;
  margin: 15px auto;
  background: #2dc5e0;
  color: #fff;
  font-size: 18px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.submit-btn > button {
  background: #2dc5e0;
  color: #fff;
  font-size: 18px;
}
.showId {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
}
.showId-view {
  width: 90%;
  height: 218px;
  background: white;
  margin: 0 auto;
  position: relative;
  top: 36%;
  text-align: center;
}
.showId-view > img {
  width: 282px;
  height: 120px;
  margin-top: 31px;
}
.close {
  width: 25px;
  height: 25px;
  float: right;
  position: relative;
  top: 0;
  right: 10px;
}
.close > img {
  width: 10px;
  height: 10px;
}
.showId-btn {
  width: 60%;
  height: 35px;
  margin: 0 auto;
  background: #2dc5e0;
  color: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  margin-top: 10px;
}
.file {
  width: 60%;
  height: 35px;
  margin: 0 auto;
  background: #2dc5e0;
  color: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  margin-top: 10px;
  position: relative;
  overflow: hidden;
  text-decoration: none;
  text-indent: 0;
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
.DelImg {
  width: 0% !important;
  height: 0rpx !important;
  margin: 30rpx !important;
  border: none !important;
  text-align: none !important;
  color: none !important;
  /* position: absolute; */
}
.rotateDelImg {
  width: 0% !important;
  height: 0rpx !important;
  margin: 30rpx !important;
  border: none !important;
  text-align: none !important;
  color: none !important;
  /* position: absolute; */
}
.DelImg > img {
  width: 14px;
  height: 14px;
  background: #ccc;
  opacity: 0.6;
  position: relative;
  top: -140px;
  left: 115px;
}
</style>
